import { FC } from "react";

import { Stack, useTheme } from "@mui/material";

import { FormBlock, FormBlockProps } from "@/forms-design-system/FormBlock";
import { FormButton } from "@/forms-design-system/FormButton";
import { FormDivider } from "@/forms-design-system/FormDivider";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedDonorsListBlockProps = Omit<FormBlockProps, "ref" | "variant" | "fullWidth"> & {
  onViewAllClick: () => void;
  showViewAllButton?: boolean;
};

export const ThemedDonorsListBlock: FC<ThemedDonorsListBlockProps> = ({
  onViewAllClick,
  children,
  showViewAllButton = false,
  ...rest
}) => {
  const theme = useTheme();
  const { t } = useTranslate();

  return (
    <FormBlock variant="card" fullWidth sx={{ padding: { xs: theme.spacing(3, 2), md: 3 } }} {...rest}>
      <Stack alignItems="flex-start" gap={2}>
        <FormTypography variant="subtitle1" vibe="intense">
          {t("donationForm", "peerToPeer.donorsCard.title")}
        </FormTypography>
        <Stack width="100%" gap={1.5} divider={<FormDivider />}>
          {children}
        </Stack>
        {showViewAllButton && (
          <FormButton variant="outline" size="small" onClick={onViewAllClick}>
            {t("donationForm", "peerToPeer.donorsCard.viewAll")}
          </FormButton>
        )}
      </Stack>
    </FormBlock>
  );
};
